import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import Pais from './component/pais';
import PageTitle from '../../../../Layout/AppMain/PageTitle';



export default class PaisComponent extends React.Component {

    render() {

        return (
         <Pais></Pais>
        )
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Pais/index.js